import React from "react";
import MdTextField from "@material-ui/core/TextField";
import { useField, useFormikContext } from "formik";

interface TextFieldProps {
  label: string;
  autoComplete?: HTMLInputElement["autocomplete"];
  type?: HTMLInputElement["type"];
  fullWidth?: boolean;
  multiline?: boolean;
  rows?: number;
  disabled?: boolean;
  required?: boolean;
  name: string;
  min?: number;
}
const TextField = ({
  label,
  autoComplete,
  type,
  fullWidth,
  multiline,
  rows,
  disabled,
  required,
  name,
  min,
}: TextFieldProps) => {
  const [field] = useField(name);
  const { isSubmitting } = useFormikContext();

  return (
    <MdTextField
      margin="normal"
      id={name}
      label={label}
      variant="outlined"
      fullWidth={fullWidth}
      multiline={multiline}
      rows={rows}
      autoComplete={autoComplete}
      disabled={isSubmitting || disabled}
      required={required}
      type={type}
      value={field.value}
      onChange={field.onChange}
      onBlur={field.onBlur}
      inputProps={
        min !== undefined ? { inputMode: "numeric", min, step: 1 } : undefined
      }
    />
  );
};
TextField.defaultProps = {
  autoComplete: "off",
  type: "text",
  fullWidth: false,
  multiline: false,
  rows: 0,
  disabled: false,
  required: false,
  min: undefined,
};

export default TextField;
